import { createAsyncThunk } from '@reduxjs/toolkit';
import { Dispatch, SetStateAction } from 'react';
import { ErrorToast, SuccessToast } from '../../../components';
import {
  exchangeUsdtToClubAsync,
  exchangeUsdtToMLPAsync,
  exchangeClubToMLPAsync
} from './TopUp.requests';
import {
  changeAvailableRewardPoints,
  changeAvailableShoppingPoints,
  changeMyLifePoints
} from '../../../slices/auth-slice';
import { RootState } from '../../../app/store';
import { setUserToLS } from '../../../helpers/localstorage-helper';

export const exchangeUsdtToClub = createAsyncThunk(
  'exchangeUsdtToClub',
  async (
    {
      amount,
      setAmount,
      setTopUp
    }: {
      amount: number;
      setAmount: Dispatch<SetStateAction<string>>;
      setTopUp: Dispatch<SetStateAction<boolean>>;
    },
    { dispatch, getState }
  ) => {
    try {
      const { data } = await exchangeUsdtToClubAsync({
        amount
      });

      const state = getState() as RootState;

      setAmount('');
      setTopUp(false);
      SuccessToast();

      const user = {
        ...state.auth.userInfo,
        user: {
          ...state.auth.userInfo.user,
          userTickets: {
            ...state.auth.userInfo.user.userTickets,
            shoppingPoints: data.userTickets.shoppingPoints,
            availableRewardPoints: data.userTickets.availableRewardPoints
          }
        }
      };

      setUserToLS(user);

      dispatch(changeAvailableShoppingPoints(data.userTickets.shoppingPoints));

      dispatch(
        changeAvailableRewardPoints(data.userTickets.availableRewardPoints)
      );

      return data.userTickets;
    } catch (error: any) {
      ErrorToast(error.response.data.error);
    }
  }
);

export const exchangeUsdtToMLP = createAsyncThunk(
  'exchangeUsdtToMLP',
  async (
    {
      amount,
      setAmount,
      setTopUp
    }: {
      amount: number;
      setAmount: Dispatch<SetStateAction<string>>;
      setTopUp: Dispatch<SetStateAction<boolean>>;
    },
    { dispatch, getState }
  ) => {
    try {
      const { data } = await exchangeUsdtToMLPAsync({
        amount
      });

      const state = getState() as RootState;

      setAmount('');
      setTopUp(false);
      SuccessToast();

      const user = {
        ...state.auth.userInfo,
        user: {
          ...state.auth.userInfo.user,
          userTickets: {
            ...state.auth.userInfo.user.userTickets,
            shoppingPoints: data.userTickets.shoppingPoints,
            availableRewardPoints: data.userTickets.availableRewardPoints,
            myLifePoints: data.userTickets.myLifePoints
          }
        }
      };

      setUserToLS(user);

      dispatch(changeAvailableShoppingPoints(data.userTickets.shoppingPoints));

      dispatch(changeMyLifePoints(data.userTickets.availableRewardPoints));

      return data.userTickets;
    } catch (error: any) {
      ErrorToast(error.response.data.error);
    }
  }
);

export const exchangeClubToMLP = createAsyncThunk(
  'exchangeClubToMLP',
  async (
    {
      amount,
      setAmount,
      setTopUp
    }: {
      amount: number;
      setAmount: Dispatch<SetStateAction<string>>;
      setTopUp: Dispatch<SetStateAction<boolean>>;
    },
    { dispatch, getState }
  ) => {
    try {
      const { data } = await exchangeClubToMLPAsync({
        amount
      });

      const state = getState() as RootState;

      setAmount('');
      setTopUp(false);
      SuccessToast();

      const user = {
        ...state.auth.userInfo,
        user: {
          ...state.auth.userInfo.user,
          userTickets: {
            ...state.auth.userInfo.user.userTickets,
            shoppingPoints: data.userTickets.shoppingPoints,
            availableRewardPoints: data.userTickets.availableRewardPoints,
            myLifePoints: data.userTickets.myLifePoints
          }
        }
      };

      setUserToLS(user);

      dispatch(
        changeAvailableRewardPoints(data.userTickets.availableRewardPoints)
      );

      dispatch(changeMyLifePoints(data.userTickets.availableRewardPoints));

      return data.userTickets;
    } catch (error: any) {
      ErrorToast(error.response.data.error);
    }
  }
);
